import { render, staticRenderFns } from "./rangeDetail.vue?vue&type=template&id=ddd479fa&scoped=true&"
import script from "./rangeDetail.vue?vue&type=script&lang=js&"
export * from "./rangeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd479fa",
  null
  
)

export default component.exports